import { lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/i18n/LanguageContext";
import ScrollToTop from "./components/ScrollToTop";
import LanguageRedirect from "./components/LanguageRedirect";

// Lazy load all page components
const Index = lazy(() => import("./pages/Index"));
const KaihdinAsennus = lazy(() => import("./pages/KaihdinAsennus"));
const ParvekeAsennus = lazy(() => import("./pages/ParvekeAsennus"));
const RullaverhoAsennus = lazy(() => import("./pages/RullaverhoAsennus"));
const LamelliverhoAsennus = lazy(() => import("./pages/LamelliverhoAsennus"));
const VerhokiskoAsennus = lazy(() => import("./pages/VerhokiskoAsennus"));
const IndexEn = lazy(() => import("./pages/en/IndexEn"));
const BlindInstallation = lazy(() => import("./pages/en/BlindInstallation"));
const BalconyInstallation = lazy(() => import("./pages/en/BalconyInstallation"));
const RollerBlindInstallation = lazy(() => import("./pages/en/RollerBlindInstallation"));
const VerticalBlindInstallation = lazy(() => import("./pages/en/VerticalBlindInstallation"));
const CurtainTrackInstallation = lazy(() => import("./pages/en/CurtainTrackInstallation"));
const Tietosuoja = lazy(() => import("./pages/Tietosuoja"));
const PrivacyPolicy = lazy(() => import("./pages/en/PrivacyPolicy"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <LanguageProvider>
          <ScrollToTop />
          <LanguageRedirect />
          <Suspense fallback={<div className="min-h-screen" />}>
            <Routes>
              {/* Finnish routes */}
              <Route path="/" element={<Index />} />
              <Route path="/kaihdin-asennus" element={<KaihdinAsennus />} />
              <Route path="/parveke-asennus" element={<ParvekeAsennus />} />
              <Route path="/rullaverho-asennus" element={<RullaverhoAsennus />} />
              <Route path="/lamelliverho-asennus" element={<LamelliverhoAsennus />} />
              <Route path="/verhokisko-asennus" element={<VerhokiskoAsennus />} />
              <Route path="/tietosuoja" element={<Tietosuoja />} />
              {/* English routes */}
              <Route path="/en" element={<IndexEn />} />
              <Route path="/en/blind-installation" element={<BlindInstallation />} />
              <Route path="/en/balcony-installation" element={<BalconyInstallation />} />
              <Route path="/en/roller-blind-installation" element={<RollerBlindInstallation />} />
              <Route path="/en/vertical-blind-installation" element={<VerticalBlindInstallation />} />
              <Route path="/en/curtain-track-installation" element={<CurtainTrackInstallation />} />
              <Route path="/en/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </LanguageProvider>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
